<div
  class="container"
  tabindex="0"
  [class.dark]="dark"
  (click)="onClick($event)"
  [class.loading]="loading"
  [class.disabled]="disabled"
  [class.readonly]="readonly"
>
  <p>{{ label }}</p>
  <input
    type="checkbox"
    (click)="onInputClick($event)"
    [checked]="checked"
    #input
    [disabled]="disabled || loading"
  />
  <span class="checkmark" [class.indeterminate]="indeterminate"></span>
</div>
